<template>
  <div>
    <h4>
      {{projectType|capitalize}} Permit Application
    </h4>
    <span>
      Please select from one of the following:
    </span>
    <div class="row align-items-end">
      <div class="col-12 col-md mt-3">
        <label>For <strong>new projects:</strong></label><br>
        <router-link :to="{name: 'PermitApplication', params: {projectType: projectType}}"
                     class="btn btn-primary btn-block">
          Apply for a New Permit
        </router-link>
      </div>
      <div class="col-12 col-md mt-3">
        <label>For <strong>incomplete applications:</strong></label>
        <router-link :to="{name: 'PermitSearch', params: {projectType: projectType}}"
                     class="btn btn-primary btn-block">
          Complete Saved Application
        </router-link>
      </div>
      <div class="col-12 col-md mt-3">
        <label>For <strong>revisions to existing permits:</strong></label><br>
        <router-link :to="{name: 'RevisionSearch', params: {projectType: projectType}}"
                     class="btn btn-primary btn-block">
          Complete <span class="d-none d-lg-inline-block">Permit</span> Revision Form
        </router-link>
      </div>
      <div class="col-12 col-md mt-3">
        <label>
          For <strong>approved permits:</strong>
        </label>
        <br>
        <router-link :to="{name: 'PermitLookup'}"
                     class="btn btn-primary btn-block">
          Search For Approved Permits
        </router-link>
      </div>
    </div>

    <div class="row align-items-end" v-if="projectType == 'demolition'">
      <div class="col col-md-3 mt-3">
        <label>
          For <strong>approved permits:</strong>
        </label>
        <br>
        <router-link :to="{name: 'DDDInformation', params: {projectType: projectType}}"
                     class="btn btn-primary btn-block">
          Submit DDD Information
        </router-link>
      </div>
      <div class="col col-md-6 mt-3">
        Please note: Cook County no longer uses Green Halo for Demolition Debris Diversion Reporting.
        Click the button to the left to enter quantities of materials reused and/or recycled.
      </div>
    </div>
      <div class="row align-items-end">
        <div class="col-123 col-md mt-3" v-if="projectType == 'asbestos'">
          <label>
            For <strong>O&M Renewal:</strong>
          </label>
          <br>
          <router-link :to="{name: 'OpAndMainSelect'}"
                       class="btn btn-primary btn-block">
            Renew O&M Permits
          </router-link>
        </div>
        <div class="col-12 col-md mt-3"></div>
        <div class="col-12 col-md mt-3"></div>
        <div class="col-12 col-md mt-3"></div>
      </div>
    </div>
</template>

<script>
import { CapitalizeFilter } from '@/js/Mixins';

export default {
  name: 'DemolitionLanding',
  props: ['projectType'],
  mixins: [CapitalizeFilter],
  mounted() {
    this.$store.commit('temporaryForm', null);
  },
};
</script>
